import { InjectionToken } from '@angular/core';

export const VIMEO_API_TOKEN = new InjectionToken('Vimeo API URL');
export const VIMEO_API = 'https://vimeo.com/api';
export const VIMEO_LIVE_CHAT_TOKEN = new InjectionToken('Vimeo live chat URL');
export const VIMEO_LIVE_CHAT = 'https://vimeo.com/live-chat';
